import { render, staticRenderFns } from "./Distribusi.vue?vue&type=template&id=01d19518"
import script from "./Distribusi.vue?vue&type=script&lang=js"
export * from "./Distribusi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports